<template>
  <footer class="footer">
    <div class="footer-inner">
      <img src="../assets/svg/ecpat-logo.svg" class="logo" />
    </div>
  </footer>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
.footer {
  //background-color: $green;
  background-image: url('~@/assets/svg/footer-bg.svg');
  background-position: 50% 0%;
  background-repeat: no-repeat;
  background-size: 100%;
  color: #fff;
}

.footer-inner {
  margin: auto;
  max-width: $content-max-width;
  padding: 60px 20px 40px;
}

.logo {
  display: block;
  margin: auto;
}

.footer-text {
  margin-left: auto;
  margin-right: auto;
  margin-top: 60px;
  max-width: $content-max-width;
}

.Cookie--ecpat {
  background-color: $black;
  padding: 20px;

  .Cookie__content {
    margin: auto;
    max-width: $content-max-width;

    p {
      margin: 0;
      margin-bottom: 20px;
    }

    a {
      color: $white;
      text-decoration: underline;
    }
  }
}

@media screen AND (min-width: $medium-screen) {
  .footer-inner {
    align-items: center;
    display: flex;
    justify-content: space-evenly;
    margin: auto;
    max-width: $section-max-width;

    > * {
      margin-left: 0;
      margin-right: 0;
    }
  }
}
</style>
